export default __webpack_public_path__ + "static/media/resolution.50d7f122.jpg";